const stats = [
  { value: "120+", label: "Projects shipped" },
  { value: "40+", label: "Enterprise clients" },
  { value: "9/10", label: "Client NPS" },
  { value: "48h", label: "Avg. time to first hire" },
];

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="bg-[color:var(--fis-ink)] text-white"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-2 md:grid-cols-4 gap-10">
        {stats.map((s) => (
          <div key={s.label} className="border-l border-white/15 pl-6">
            <div className="font-display text-5xl md:text-6xl">{s.value}</div>
            <div className="font-mono-label text-white/60 mt-3">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
